import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './valveSystem.css';
import { SECTION_PAUSED_EVENT } from './valveEvents';
import ValvePopup from './ValvePopup';

/**
 * ValvePauseGate — mounted once in App.js. Listens for the section-paused event
 * (raised by the axios clients when a paused valve 503s a non-exempt user) and
 * shows the approved pop-up (FINAL-valve-popup.html) over the dimmed page.
 *
 * Behavior:
 *  - when a member hits a closed area (503 sectionPaused) the pop-up appears:
 *    "We're making improvements." / "It will be available again soon." /
 *    Check status → /status / let us know
 *  - if the member is already ON /status (the door) nothing pops
 *  - dismissible ✕ / Esc / backdrop; a short cooldown prevents background
 *    poll 503s from instantly re-opening it after a deliberate close
 */

const REOPEN_COOLDOWN_MS = 6000;

const ValvePauseGate = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const closedAt = useRef(0);

  useEffect(() => {
    const onPaused = (e) => {
      if (location.pathname === '/status') return; // already on the door
      if (open) return;                            // already showing
      const now = Date.now();
      if (now - closedAt.current < REOPEN_COOLDOWN_MS) return;
      setOpen(true);
    };
    window.addEventListener(SECTION_PAUSED_EVENT, onPaused);
    return () => window.removeEventListener(SECTION_PAUSED_EVENT, onPaused);
  }, [location.pathname, open]);

  if (!open) return null;

  return <ValvePopup onClose={() => { closedAt.current = Date.now(); setOpen(false); }} />;
};

export default ValvePauseGate;
